import { render, staticRenderFns } from "./MyPreview.vue?vue&type=template&id=212c97cb&scoped=true&"
import script from "./MyPreview.vue?vue&type=script&lang=js&"
export * from "./MyPreview.vue?vue&type=script&lang=js&"
import style0 from "./MyPreview.vue?vue&type=style&index=0&id=212c97cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212c97cb",
  null
  
)

export default component.exports